import styled from 'styled-components';
import { elevation3, inverseOnSurface, inverseSurface, onSurface, onSurfaceVariant, radiusFull, radiusMedium, surfaceHigh } from './themeTokens';

export const PanelCard = styled.section`
  position: absolute;
  right: 12px;
  bottom: 52px;
  z-index: 1;
  width: max-content;
  min-width: 224px;
  max-width: calc(100% - 24px);
  box-sizing: border-box;
  padding: 8px 12px 12px;
  border-radius: ${radiusMedium};
  background: ${surfaceHigh};
  box-shadow: ${elevation3};
  color: ${onSurface};
  pointer-events: auto;
`;

export const PanelHeading = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 28px;
`;

export const PanelTitle = styled.h3`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PanelRows = styled.dl`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 4px 12px;
  margin: 4px 0 0;
  font-size: 12px;
`;

export const PanelLabel = styled.dt`
  margin: 0;
  color: ${onSurfaceVariant};
`;

export const PanelValue = styled.dd`
  margin: 0;
  text-align: right;
  font-variant-numeric: tabular-nums;
`;

export const PanelHint = styled.p`
  margin: 4px 0 0;
  font-size: 12px;
  color: ${onSurfaceVariant};
`;

export const MeasureLabel = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  padding: 3px 8px;
  border-radius: ${radiusFull};
  background: ${inverseSurface};
  color: ${inverseOnSurface};
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  pointer-events: none;
  visibility: hidden;
`;
